import { DashboardItem } from '../components/catalog/types';

interface OrderArgs {
  maxAmount?: number;
  items?: any;
}

class Order {
  maxAmount?: number;
  items?: any;

  constructor(args?: OrderArgs) {
    this.maxAmount = (args && args.maxAmount) || 0;
    this.items = (args && args.items) || {};

    this._getFromSession();
  }

  increment(id: string, item: DashboardItem) {
    if (this.items[id]) {
      this.items[id].count++;
    } else {
      if (item) {
        this.items[id] = {
          count: 1,
          price: item.price,
          product_code: item.product_code,
          title: item.title,
        };
      } else {
        this.items[id] = {
          count: 1,
        };
      }
    }
    this._addToSession();
  }

  decrement(id: string) {
    if (this.items[id]) {
      this.items[id].count--;
      this._addToSession();
    }
  }

  remove(id: string) {
    delete this.items[id];
    this._addToSession();
  }

  _getFromSession() {
    if (typeof window === 'undefined') {
      return;
    }

    const existing = JSON.parse(window.sessionStorage.getItem('order'));
    if (existing) {
      this.items = existing.items;
    }
  }

  _addToSession() {
    if (typeof window === 'undefined') {
      return;
    }

    window.sessionStorage.setItem(
      'order',
      JSON.stringify({
        items: this.items,
      })
    );
  }

  get total() {
    if (!this.items || !Object.keys(this.items).length) {
      return 0;
    }

    return Object.keys(this.items).reduce((total, currentId) => {
      return total + parseFloat(this.items[currentId].price) * this.items[currentId].count;
    }, 0);
  }

  get remainingAmount() {
    return this.maxAmount - this.total;
  }

  get valid() {
    return this.remainingAmount >= 0;
  }
}

export default Order;
